import { Link } from 'react-router-dom'

import { Footer } from '@/components/Footer'
import { SEO } from '@/components/SEO'
import { SEO_CONFIG } from '@/constants/seo'

export const NotFoundPage = () => {
    return (
        <>
            <SEO
                title='404 - Page Not Found | Nexly'
                description='The page you are looking for does not exist.'
                canonical={`${SEO_CONFIG.siteUrl}/404`}
                ogImage={SEO_CONFIG.ogImage}
            />
            <div className='min-h-[calc(100vh-200px)] flex items-center justify-center py-20'>
                <div className='text-center px-4'>
                    <h1 className='text-6xl font-bold mb-4'>404</h1>
                    <h2 className='text-3xl font-semibold mb-6'>Page Not Found</h2>
                    <p className='text-gray-600 mb-8 text-lg'>
                        The page you are looking for does not exist.
                    </p>
                    <Link
                        to='/'
                        className='inline-block px-8 py-4 bg-primary text-white text-lg font-semibold rounded-lg hover:bg-primary-hover transition-colors shadow-lg'
                    >
                        Go to Home
                    </Link>
                </div>
            </div>
            <Footer/>
        </>
    )
}
